import { Button } from "@mantine/core";

import { useUpdateUser } from "../../api/user";
import { useDeleteConfirm } from "../../hooks/useDeleteConfirm";

const DeleteProfilePicture = ({ userId, ...props }) => {
  const { mutate, isPending } = useUpdateUser({
    id: userId,
  });
  const confirmDelete = useDeleteConfirm("picture", mutate);

  return (
    <Button
      loading={isPending}
      onClick={() => confirmDelete({ picture: null })}
      variant="light"
      color="red"
      {...props}
    >
      Delete profile picture
    </Button>
  );
};

export default DeleteProfilePicture;
